/** Public, finite selections only. Never turn arbitrary URL text into chart data. */
export function climateSelection<T extends string>(
  search: string,
  key: string,
  fallback: T,
  allowed: readonly T[],
): T {
  const values = new URLSearchParams(search).getAll(key);
  return values.length === 1 ? allowed.find((entry) => entry === values[0]) ?? fallback : fallback;
}

export function climateSelectionUrl<T extends string>(
  href: string,
  key: string,
  value: T,
  allowed: readonly T[],
): string | null {
  if (!allowed.includes(value)) return null;
  const url = new URL(href);
  url.searchParams.set(key, value);
  return `${url.pathname}${url.search}${url.hash}`;
}
